import type { CandidateRequestParams } from '@entities/candidates';
import { PaginateType } from '@shared/types';
import type {
  CandidateResumeAppliedFilters,
  CandidateResumeSort,
} from '../types';

type GetCandidateResumeListRequestParams = {
  filters: CandidateResumeAppliedFilters;
  sort: CandidateResumeSort;
  page: number;
  pageSize: number;
};

const SORT_FIELDS = {
  desiredJob: 'desiredJob',
  salary: 'salary',
  scheduleWorks: 'scheduleWorks.name',
  employmentTypes: 'employmentTypes.name',
} as const;

export const getCandidateResumeListRequest = ({
  filters,
  sort,
  page,
  pageSize,
}: GetCandidateResumeListRequestParams): CandidateRequestParams => {
  const filter: Record<string, { items: string[]; operator: 'or' }> = {};

  if (filters.desiredJob.trim()) {
    filter.desiredJob = {
      items: [filters.desiredJob.trim()],
      operator: 'or',
    };
  }

  if (filters.employmentTypeId !== null) {
    filter['employmentTypes.id'] = {
      items: [filters.employmentTypeId.toString()],
      operator: 'or',
    };
  }

  if (filters.scheduleWorkId !== null) {
    filter['scheduleWorks.id'] = {
      items: [filters.scheduleWorkId.toString()],
      operator: 'or',
    };
  }

  if (filters.isActive !== null) {
    filter.is_active = {
      items: [filters.isActive.toString()],
      operator: 'or',
    };
  }

  return {
    filter,
    sort: sort ? { [SORT_FIELDS[sort.field]]: sort.direction } : undefined,
    page,
    perPage: pageSize,
    paginate: PaginateType.DEFAULT,
  };
};
